<template>
  <div class="assestment-item" :style="{ backgroundColor: getAssestmentColor }">
    <h4 class="assestment-item__title">{{ assestment.rate }}</h4>

    <div class="assestment-item__body">
      <p v-if="assestment.note" class="assestment-item__start-again">
        Qeyd: <span>{{ assestment.note }}</span>
      </p>

      <p v-if="assestment.execStructure">
        Aidiyyəti təşkilat: {{ assestment.execStructure.name }}
      </p>

      <span class="assestment-item__start-again">
        {{ assestment.rate }}
        <a-rate
          v-model="assestment.score"
          :count="3"
          :allowClear="false"
          disabled
        />
      </span>

      <span class="assestment-item__start-again">
        Təkrar Müraciət: <span>{{ getStartAgainStr }}</span>
      </span>
    </div>

    <div class="assestment-item__footer">
      <button
        v-if="assestment.files && assestment.files.length > 0"
        class="assestment-item__view-files-btn"
        @click="handleSelectFilesToDisplay"
      >
        Fayllar
      </button>

      <div class="assestment-item__date">{{ getDateStr }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    assestment: Object,
  },
  computed: {
    getAssestmentColor() {
      switch (this.assestment.score) {
        case 1:
          return "#FF5252";
        case 2:
          return "#FB8C00";
        case 3:
          return "#4CAF50";
        default:
          return "#2196F3";
      }
    },

    getStartAgainStr() {
      if (this.assestment.startAgain) return "Təsdiq";
      else return "İmtina";
    },

    getDateStr() {
      return this.assestment.opDateStr;
    },
  },
  methods: {
    handleSelectFilesToDisplay() {
      this.$emit("selected", this.assestment.files);
    },
  },
};
</script>

<style lang="scss" scoped src="./index.scss"></style>
